import React from 'react';

import { LiveTvChannel } from '@smart-tv/typings/content';
import PlayerInformation from '../player-information';
import { usePlayerContext } from '../_contexts/player-context';

interface Props {
  channel?: LiveTvChannel;
}

export const PlayerLoadingInfo: React.FC<Props> = (props: Props) => {
  const { channel } = props;

  const { firstTimeLoading } = usePlayerContext();

  if (!firstTimeLoading || !channel) return null;

  return <PlayerInformation channel={channel} />;
};

export default React.memo(PlayerLoadingInfo);
